export default "__VITE_ASSET__DkRsIKd5__"